<template>
    <div class="iframe-container">
        <iframe
            v-if="isYouTube && video_url"
            frameBorder="0"
            scrolling="no"
            allow="autoplay"
            allowfullscreen
            @load="loadVideo"
            :src="video_url">
        </iframe>

        <video
            v-else-if="video_url"
            class="html5-video"
            controls
            playsinline
            preload="metadata"
            @loadeddata="loadVideo"
        >
            <source :src="video_url" :type="videoMimeType" />
            Your browser does not support this video format.
        </video>
    </div>
</template>

<script>
    export default {
        name: "VideoPlayer",

        props: {
            video_id: String,
            video_src: String,
            video_type: String,
        },

        data() {
            return {
                show_video: false,
                show_loader: true
            };
        },

        computed: {
            isYouTube: function () {
                return this.video_src === 'YouTube'
            },

            video_url: function () {
                return this.isYouTube
                    ? `https://www.youtube.com/embed/${this.video_id}?controls=1`
                    : this.video_id
            },

            videoMimeType: function () {
                const url = (this.video_id || '').toLowerCase()

                if (url.endsWith('.mp4')) return 'video/mp4'
                if (url.endsWith('.mov')) return 'video/quicktime'
                if (url.endsWith('.webm')) return 'video/webm'
                return 'video/mp4'
            }
        },

        mounted () {
            if (this.isYouTube) this.loadVideo()
        },

        methods: {
            loadVideo: function () {
                this.show_video = true
                this.show_loader = false
            }
        }
    }
</script>

<style scoped>
    .iframe-container {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%;
        height: 0;
    }

    .iframe-container iframe,
    .iframe-container .html5-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/video/VideoPlayer.vue